export default {
  listaPagamentoRecebimentos: [],
  pagamentoRecebimento: {
    id: '',
    registro: '',
    descricao: '',
    dataLancamento: null,
    dataVencimento: null,
    dataQuitacao: null,
    valor: 0.00,
    desconto: 0.00,
    juro: 0.00,
    multa: 0.00,
    valorTotal: 0.00,
    valorQuitado: 0.00,
    obs: null,
    tipo: null,
    formaPagamento: null,
    situacao: null,
    ativo: true,
  },
  comboSituacao: [
    { id: 0, nome: 'Aberto' },
    { id: 1, nome: 'Vencido' },
    { id: 2, nome: 'Quitado' },
    { id: 3, nome: 'Pago a menor' },
  ],
  TIPO_PAGAMENTO: 0,
  TIPO_RECEBIMENTO: 1,
}
